module.exports = __webpack_public_path__ + "static/media/link_03.0d07fbab.jpg";